import { Component } from '@angular/core';

@Component({
  selector: 'lib-data-form-card',
  standalone: true,
  template: `
    <section class="data-form-card">
      <ng-content />
    </section>
  `,
  styles: [`
    .data-form-card {
      border: 1px solid #e2e8f0;
      border-radius: 12px;
      background: #ffffff;
      padding: 14px;
    }
  `],
})
export class DataFormCardComponent {}
